module.exports = __webpack_public_path__ + "static/aubergine-be8277334ba03ce3cf1a7c3498d59ac9.svg";